var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0517 4.23937L15.4575 2.83271C15.7506 2.53964 16.148 2.375 16.5625 2.375C16.977 2.375 17.3744 2.53964 17.6675 2.83271C17.9606 3.12577 18.1252 3.52325 18.1252 3.93771C18.1252 4.35216 17.9606 4.74964 17.6675 5.04271L5.69333 17.0169C5.25277 17.4572 4.70947 17.7808 4.1125 17.9585L1.875 18.6252L2.54167 16.3877C2.7194 15.7907 3.04303 15.2474 3.48333 14.8069L14.0525 4.23937H14.0517ZM14.0517 4.23937L16.25 6.43771",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.b1639792fde8db45810f367d255e5ca6.svg";
export { ForwardRef as ReactComponent };